import {  sendApi } from ".";
import { T_Trouble } from "../model/troubleModel";

async function troubleList(data?: any) {
    const response = await sendApi({
      method: "post",
      url: "/trouble/list",
      data: {
        ...data,
      },
    });
    console.log(response)
    return response;
  }

async function troubleCreate(data1?:T_Trouble){

  const response = await sendApi({
    method: "post",
    url: "/trouble/insert",
    isForm:true,
    data: {
      ...data1,
    },
  });

  console.log(response.data)
  return response;
}  

async function troubleDelete(data1?:T_Trouble){

  const response = await sendApi({
    method: "post",
    url: "/trouble/delete",
    data: {
      ...data1,
    },
  });
  return response;
}  


async function troubleInfo(data1?:T_Trouble){

  const response = await sendApi({
    method: "post",
    url: "/trouble/info",
    data: {
      ...data1,
    },
  });
  return response;
}  

const trouble = {
    troubleList,
    troubleCreate,
    troubleDelete,
    troubleInfo,
  };
  export default trouble;

